export default "__VITE_ASSET__071feb90__"